import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import translate from '../../libs/i18n';


import Loading from '../Loading/Loading';
import NotificationList from '../NotificationList/NotificationList';
import Cookies from 'js-cookie';
import DefaultAvatar from '../../assets/svgs/DefaultAvatar';
import MenuIcon from '../../assets/svgs/MenuIcon';
import NotificationIcon from '../../assets/svgs/NotificationIcon';
import ChevronIcon from '../../assets/svgs/ChevronIcon';
import LogOut from '../../assets/svgs/LogOut';
import ForgotPassword from '../../assets/svgs/ForgotPassword';
import Logotypes from '../../assets/svgs/Logotypes';

import Api from '../../libs/Api';
import authenticationCheck from '../../libs/authenticationCheck';
import { useBreakpoint } from '../../utils/useBreakpoint';
import { useIsMounted } from '../../utils/useIsMounted';
import { useDisableBodyScroll } from '../../utils/useDisableBodyScroll';
import { setExamsAdded, setUploadExams } from '../../store/actions/exams';
import { setLanguage, clearSettings } from '../../store/actions/settings';
import { unregisterMeUser } from '../../store/actions/meUser';
import { breakpoints } from '../../ui/variables';

import { HeaderStyle } from './HeaderStyle';
import ProfileIcon from '../../assets/svgs/ProfileIcon';

const Header = ({ handleShowMenu }) => {
  const breakpoint = useBreakpoint();
  const dispatch = useDispatch();
  const history = useHistory();
  const isMounted = useIsMounted();
  const language = useSelector((state) => state.settings.language);
  const user = useSelector((state) => state.meUser);

  const [hasUnseenNotifications, setHasUnseenNotifications] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const [requestForNewNotifications, setRequestForNewNotifications] =
    useState(false);

  useDisableBodyScroll(openNotification);

  useEffect(() => {
    (async () => {
      if (authenticationCheck()) {
        Api.getNotifications().then((response) => {
          if (response.data && response.data.length) {
            const currentHasUnseenNotifications = response.data.some(
              (notification) => notification.viewed === false
            );
            const currentNotificationList = response.data;

            if (isMounted()) {
              setNotificationList(currentNotificationList);
              setHasUnseenNotifications(currentHasUnseenNotifications);
            }
          }
        });

        const timeout = setTimeout(() => {
          if (isMounted()) {
            setRequestForNewNotifications(!requestForNewNotifications);
          }
        }, 5 * 60 * 1000);

        return () => clearTimeout(timeout);
      }

      return null;
    })();
  }, [isMounted, requestForNewNotifications]);

  const isMobile = useMemo(
    () => breakpoint.width < breakpoints.ipadLandscape.width,
    [breakpoint.width]
  );

  const handLeogout = () => {
    setLoading(true);

    localStorage.clear('hcatkn');
    localStorage.clear('hcrtkn');

    Cookies.remove('orthanc_token');
    Cookies.remove('refresh_token');
    
    dispatch(unregisterMeUser());
    dispatch(clearSettings());
    dispatch(setExamsAdded([]));
    dispatch(setUploadExams([]));

    setLoading(false);

    history.push('/entrar');
  };

  return (
    <HeaderStyle>
      <div className="header-menu">
        {authenticationCheck() && handleShowMenu && isMobile ? (
          <button
            type="button"
            className="show-menu-button"
            onClick={handleShowMenu}
          >
            <MenuIcon />
          </button>
        ) : (
          <Link to="/entrar">
            <Logotypes theme="white" />
          </Link>
        )}
      </div>
      <div className="select-language-tool">
        <button
          type="button"
          className="select-language-button"
          onClick={() => dispatch(setLanguage('pt-br'))}
          disabled={language === 'pt-br'}
        >
          PT
        </button>
        {' | '}
        <button
          type="button"
          className="select-language-button"
          onClick={() => dispatch(setLanguage('en'))}
          disabled={language === 'en'}
        >
          EN
        </button>
      </div>
      <div className="header-actions">
        {authenticationCheck() ? (
          <div className="notification">
            <div className="notification-button-container">
              <button
                type="button"
                className="notification-button"
                onClick={() => setOpenNotification(!openNotification)}
              >
                <NotificationIcon />
                {hasUnseenNotifications ? (
                  <div className="unseen-notification" />
                ) : null}
              </button>
            </div>
            <NotificationList
              opened={openNotification}
              onClose={() => setOpenNotification(false)}
              notificationList={notificationList}
            />
          </div>
        ) : null}
        <div className="avatar-wrapper">
          <DefaultAvatar />
        </div>
        {authenticationCheck() ? (
          <>
            <button className="user-name"onClick={() => {setIsOpen(!isOpen)}}>
              {user.name}
              <span className="icon" style={{transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s'}}>
                <ChevronIcon />
              </span>
            </button>

            {isOpen && (
              <div className="user-menu">
                
                <button
                  type="button"
                  className="action-profile"
                  onClick={() => {history.push('/meu-perfil');}}
                >
                    <span className="icon-profile">
                      <ProfileIcon />
                    </span>
                    {translate('myprofile', language)}
                </button>


                <button
                  type="button"
                  className="action-password"
                  onClick={() => {history.push('/recuperar-senha');}}
                >
                    <span className="icon-password">
                      <ForgotPassword />
                    </span>
                    {translate('changePassword', language)}
                </button>

               <button
                  type="button"
                  className="action-logout"
                  onClick={handLeogout}
                >
                    <span className="icon-logout">
                      <LogOut />
                    </span>
                    {translate('logout', language)}
                </button>
              </div>
            )}
        </>
        ) : (
          <Link className="action-login" to="/entrar">
            Login
          </Link>
        )}
      </div>
      {loading ? <Loading /> : null}
    </HeaderStyle>
  );
};

Header.propTypes = {
  handleShowMenu: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.func,
  ]),
};

Header.defaultProps = {
  handleShowMenu: null,
};

export default React.memo(Header);
